<template>
  <div class="grid-x align-middle margin-top-s margin-bottom-s" v-bind="attrs" @click="onClick">
    <i class="margin-right-xs" :class="loyaltyIcon"></i>
    <div class="hnf-account-info">
      <div v-if="softSignedIn || isSignedIn" data-fs-mask>{{ username }}’s account</div>
      <div v-else>My Account</div>
      <div v-if="softSignedIn">Welcome Back!</div>
      <div v-else-if="isSignedIn && rewards.tierName" class="hnf-rewards" :class="{ small: isMcom }">
        <span v-if="isMcom" data-fs-mask>{{ capitalizeFirstLetter(rewards.tierName) }}</span>
        <span v-else data-fs-mask>{{ bcomMember }}</span>
        <br v-if="rewardBalance && !isSetarator && rewards.tierName" />
        <span v-if="rewardBalance" data-fs-mask><span v-if="isSetarator" class="hnf-separator"> | </span>{{ rewardBalance }}</span>
      </div>
      <div v-else :class="{ small: isMcom }">
        <span v-if="isMcom">Earn Star Rewards and Status</span>
        <span v-else>Earn Loyallist Rewards</span>
      </div>
    </div>
    <SignInLink v-if="!isSignedIn" class="primary" />
    <i v-else class="chevron-small-right-black chevron-small-right chevron-icon"></i>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import SignInLink from '~/components/common/SignInLink';
import useLoyalty from '~/composables/useLoyalty';
import { capitalizeFirstLetter } from '#shared/utils/StringUtil';
import { tagNavLinkClick } from '#shared/features/analytics/navigationTags';

const emit = defineEmits(['onSelect']);

const envProps = useEnvProps();
const pageData = usePageData();
const navUser = useNavUser();

const { rewards, loyaltyIcon, bothPoints, bcomMember, isNotZeroBalance, formatPrice } = useLoyalty();

const isMcom = envProps.isMcom;
const { context } = pageData.navigation;
const username = computed(() => navUser.data.username);
const isSignedIn = computed(() => !!navUser.data.isSignedIn);
const softSignedIn = computed(() => !isSignedIn.value && username.value?.length);
const rewardBalance = computed(() => {
  const { balance, expiringBalance, isRewardExpiring } = rewards.value;

  if (expiringBalance && isRewardExpiring) {
    return `${formatPrice(expiringBalance)} expiring soon!`;
  }

  if (balance && isNotZeroBalance.value) {
    return isMcom ? `${formatPrice(balance)} in Star Money` : `${formatPrice(balance)} in Rewards!`;
  }

  if (bothPoints.value) {
    return `${bothPoints.value} points`;
  }

  return null;
});

const isSetarator = computed(() => {
  const { tierName, balance, isRewardExpiring } = rewards.value;

  if (isMcom) return true;
  if (tierName === 'top') {
    if (isRewardExpiring) return false;
    return !balance || balance.toString().length < 3;
  }
  return tierName !== 'topUnlocked';
});
const attrs = computed(() => (isSignedIn.value ? { role: 'button', tabindex: 0 } : {}));

function showSubCategories() {
  if (isMcom) {
    tagNavLinkClick(isMcom, {
      context,
      topCategoryName: '',
      pos: 0,
      col: 1,
      categoryId: '',
      analyticsCategoryId: '',
      clickableElement: 'My Account',
    });
  }

  return emit('onSelect', { id: 'accountContent', title: '' });
}

function onClick() {
  if (!isSignedIn.value) return;

  showSubCategories();
}
</script>

<style lang="scss">
.hnf-account-info {
  flex: 1;
}

.hnf-separator {
  color: $gray-3-color;
}
</style>
